/**
 * author: Soumya Shreyas
 */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import {
  BiChevronDown,
} from "react-icons/bi";

const LinkDataItems = ({ t, list, handleDataSource, handleSelSource, dsId }) => {
  const [shown, setShown] = useState(false);
  const [selDataSource, setSelDataSource] = useState(dsId ? dsId : "");

  useEffect(() => { }, [list]);
  const handleChangeDs = (e, id, name) => {
    const newVal = !shown[id];
    setShown({
      ...shown,
      [id]: !shown[id],
    });

    handleDataSource(id, name);
  };
  const handleSelDs = (e, id) => {
    setSelDataSource(id);
    handleSelSource(id);
  };

  return (
    <>

      {list?.length > 0
        ? list?.map((item, index) => (
          <div className="card RSW_Add_Card" key={item.id} id={item.id}>
            <div className="card-body p-0">
              <div className="RSW_Add_Card_row01">

                {item?.children?.length > 0 && (
                  <div className="expand_RswBox 3">
                    <BiChevronDown
                      onClick={(e) => handleChangeDs(e, item.id, item.name)}
                      aria-controls="example-collapse-text"
                      aria-expanded={shown[item.id]}
                    /> </div>)}


                <div className="row m-0">
                  <div
                    className="col-lg-11 p-1"
                    onClick={(e) => handleChangeDs(e, item.id, item.name)}
                  >
                    <div className="row m-0 RSW_Add_Card_head 1">
                      <div className="col-lg-9 p-0">{item.name}</div>
                    </div>
                  </div>
                  <div className="col-lg-1 p-0">
                    {item.assignable && (

                      <input
                        type="radio"
                        value={item.id}
                        key={item.id}
                        id={`datasourceitem_select_${item.id}`}
                        checked={selDataSource === item.id}
                        onChange={(e) => handleSelDs(e, item.id)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
        : t("NoData.label")}
    </>
  );
};
LinkDataItems.propTypes = {};
export default withTranslation()(LinkDataItems);
